<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-select
                          :items="listjenisdata"
                          name="jenisdata"
                          v-model="filter.jenisdata"
                          label="Jenis Data">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.olahraga"
                          :items="listolga"
                          item-value="nama_olga"
                          item-text="nama_olga"
                          label="Cabang Olahraga">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-autocomplete
                          multiple
                          v-model="filter.year"
                          :items="listyear"
                          label="Tahun ke-atas">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.tingkat"
                          :items="listtingkat"
                          label="Tingkat Prestasi">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          :items="listkelamin"
                          name="kelamin"
                          v-model="filter.kelamin"
                          label="Jenis kelamin">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.kecamatan"
                          :items="listkecamatan"
                          item-value="kecamatan"
                          item-text="kecamatan"
                          label="Kecamatan"
                          @change="getKelurahan(filter.kecamatan)">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="5" v-if="filter.kecamatan !== varsemua">
                        <v-autocomplete
                          v-model="filter.kelurahan"
                          :items="listkelurahan"
                          item-value="kelurahan"
                          item-text="kelurahan"
                          label="Kelurahan / Desa">
                          <template v-slot:selection="data">
                            <v-chip small label class="chip-h-auto">
                              <div>
                                <strong>{{ data.item.kelurahan }}</strong> ( {{ data.item.kecamatan }}, {{ data.item.kabupaten }} )
                              </div>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.kelurahan"></v-list-item-title>
                              <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-coin</v-icon>
                            </v-list-item-action>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          color="success"
                          class="mt-1"
                          dark
                          @click="updateDashboard">
                          Ubah
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12" class="text-right py-0">
                        <span class="caption">
                          Tekan tombol <span class="red--text font-weight-bold">UBAH</span> untuk menampilkan Grafik.
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div class="text-center" v-if="loading.dashboard">
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                </div>
                <v-card
                  v-if="!loading.dashboard"
                  outlined
                  class="mx-auto text-center"
                  light>
                  <v-card-text>
                    <div
                      v-show="stockOptionsAll.series.length"
                      class="display-1">
                      <highcharts
                        class="stock"
                        :options="stockOptionsAll"
                        ref="highchartstockall">
                      </highcharts>
                    </div>
                    <h3 v-show="!stockOptionsAll.series.length">
                      Ubah parameter untuk menemukan data yang lain!
                    </h3>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" v-if="false">
                <v-card
                  outlined
                  class="mx-auto text-center"
                  light>
                  <v-card-text>
                    <v-simple-table height="400px">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Kelurahan</th>
                            <th class="text-left">Usia</th>
                            <th class="text-left">Jumlah (atlet)</th>
                          </tr>
                        </thead>
                        <tbody v-if="datasummary.length > 0">
                          <tr v-for="(item, index) in datasummary" :key="index">
                            <td class="text-left">{{ item.kel_ktp }}</td>
                            <td class="text-left">{{ item.range_umur }}</td>
                            <td class="text-left">{{ item.jumlah }}</td>
                          </tr>
                        </tbody>
                        <tbody v-if="datasummary.length <= 0">
                          <tr>
                            <td colspan="6">Data Kosong</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to=" userrole === 'admin' ? { name: 'SuratAdmin', query: { type: 'batal' } } : { name: 'SuratGuest', query: { type: 'batal' } }">
                      <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" v-if="false">
                <v-card
                  outlined
                  class="mx-auto text-center"
                  light>
                  <v-card-text>
                    <div
                      v-show="stockOptionsGender.series[0].data.length"
                      class="display-1">
                      <highcharts
                        class="stock"
                        :constructor-type="'chart'"
                        :options="stockOptionsGender"
                        ref="highchartstockgender">
                      </highcharts>
                    </div>
                    <h3 v-show="!stockOptionsGender.series[0].data.length">
                      Atlet berdasar Gender kosong
                    </h3>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to=" userrole === 'admin' ? { name: 'SuratAdmin', query: { type: 'batal' } } : { name: 'SuratGuest', query: { type: 'batal' } }">
                      <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="false">
                <v-card
                  outlined
                  class="mx-auto text-center"
                  light>
                  <v-card-text>
                    <div
                      v-show="stockOptionsJob.series[0].data.length"
                      class="display-1">
                      <highcharts
                        class="stock"
                        :options="stockOptionsJob"
                        ref="highchartstockjob">
                      </highcharts>
                    </div>
                    <h3 v-show="!stockOptionsJob.series[0].data.length">
                      Atlet berdasar Kelurahan kosong
                    </h3>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to=" userrole === 'admin' ? { name: 'SuratAdmin', query: { type: 'batal' } } : { name: 'SuratGuest', query: { type: 'batal' } }">
                      <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  data: () => ({
    loading: {
      dashboard: false,
    },
    api: process.env.VUE_APP_API,
    filter: {
      jenisdata: '',
      year: [],
      olahraga: '',
      tingkat: '',
      kelamin: '',
      kecamatan: '',
      kelurahan: '',
    },
    varsemua: 'Semua',
    listkecamatan: [],
    listkelurahan: [],
    listyear: [],
    listolga: [],
    listjenisdata: ['atlet', 'pelatih'],
    listkelamin: ['L', 'P'],
    listtingkat: ['Internasional', 'Nasional', 'Provinsi', 'Kabupaten', 'Kecamatan'],
    datasummary: [],
    stockOptionsAll: {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Profil Prestasi Atlet',
      },
      xAxis: {
        type: 'category',
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Jumlah (atlet)',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y}',
          },
        },
      },
      series: [],
    },
    stockOptionsJob: {
      chart: {
        type: 'bar',
      },
      title: {
        text: 'Atlet berdasar Kelurahan',
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Jumlah (atlet)',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y}',
          },
        },
      },
      series: [
        {
          name: 'Pekerjaan',
          colorByPoint: true,
          data: [],
        },
      ],
    },
    stockOptionsGender: {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: 'Atlet berdasar Gender',
      },
      tooltip: {
        pointFormat: 'Prosentase: <b>{point.percentage:.1f}%</b> <br/> Jumlah: <b>{point.y}</b>',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [{
        name: 'Gender',
        colorByPoint: true,
        data: [],
      }],
    },
  }),
  created: () => ({
  }),
  mounted() {
    this.getOlga();
    this.getListYear();
    this.listtingkat.push(this.varsemua);
    this.filter.jenisdata = this.listjenisdata[0];
    this.filter.kelamin = this.listkelamin[0];
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  methods: {
    getKecamatan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kecamatan',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                // kecamatan
                this.listkecamatan = resdata.data;
                this.listkecamatan.push({ kecamatan: this.varsemua });
                this.filter.kecamatan = this.listkecamatan[0].kecamatan;
                // get banjar
                this.getKelurahan(this.filter.kecamatan);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getKelurahan(kecamatan) {
      this.listkelurahan = [];
      this.filter.kelurahan = '';
      if (this.tokenscr && kecamatan !== this.varsemua) {
        this.axios
          .get(
            this.api + '/api/kodepos/kelurahan',
            {
              params: {
                kec: kecamatan,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // kelurahan
                this.listkelurahan = resdata.data;
                this.listkelurahan.push(
                  {
                    id: this.varsemua,
                    kelurahan: this.varsemua,
                    kecamatan: '-',
                    kabupaten: '-',
                  },
                );
                this.filter.kelurahan = this.listkelurahan[0].kelurahan;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getListYear() {
      this.listyear = [];
      const rangeYear = 20;
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < rangeYear; i++) {
        this.listyear.push(currentYear - i);
      }
      this.filter.year.push(this.listyear[0]);
    },
    getOlga() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisolga/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listolga = resdata.data;
                this.listolga.push({ nama_olga: this.varsemua });
                this.filter.olahraga = this.listolga[0].nama_olga;
                this.filter.tingkat = this.listtingkat[0];
                this.getKecamatan();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getTableSummary() {
      this.datasummary = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/user/dashboard/summary/',
            {
              params: {
                olga: this.filter.olahraga,
                tahun: this.filter.year,
                tingkat: this.filter.tingkat,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datasummary = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getSummaryBanjar() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/user/dashboard/summary/bybanjar',
            {
              params: {
                olga: this.filter.olahraga,
                tahun: this.filter.year,
                tingkat: this.filter.tingkat,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // console.log(resdata);
                // data job
                this.stockOptionsJob.series[0].data = [];
                if (resdata.data.length > 0) {
                  let datajob = null;
                  for (const row of resdata.data) {
                    datajob = {
                      y: parseInt(row.y, 10),
                      name: row.name,
                    };
                    this.stockOptionsJob.series[0].data.push(datajob);
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getSummaryGender() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/user/dashboard/summary/bygender',
            {
              params: {
                olga: this.filter.olahraga,
                tahun: this.filter.year,
                tingkat: this.filter.tingkat,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // console.log(resdata);
                // data gender
                this.stockOptionsGender.series[0].data = [];
                if (resdata.data.length > 0) {
                  let datagender = null;
                  for (const row of resdata.data) {
                    datagender = {
                      y: parseInt(row.y, 10),
                      name: row.name,
                    };
                    this.stockOptionsGender.series[0].data.push(datagender);
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateDashboard() {
      // console.log(this.filter);
      if (this.tokenscr) {
        this.loading.dashboard = true;
        this.stockOptionsAll.xAxis.categories = [];
        this.stockOptionsAll.series = [];
        this.axios
          .get(
            this.api + '/api/user/dashboard/summary/all',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  const kelurahan = [];
                  const olga = [];
                  for (const row of resdata.data) {
                    kelurahan.push(row.name);
                    olga.push(row.olga);
                  }
                  const kelunique = [...new Set(kelurahan)];
                  const olgaunique = [...new Set(olga)];
                  this.stockOptionsAll.xAxis.categories = kelunique;
                  let datajob = null;
                  for (const olg of olgaunique) {
                    datajob = {
                      name: olg,
                      data: [],
                    };
                    for (const kel of kelunique) {
                      for (const d of resdata.data) {
                        if (d.olga === olg && d.name === kel) {
                          datajob.data.push(parseInt(d.y, 10));
                        }
                      }
                    }
                    this.stockOptionsAll.series.push(datajob);
                  }
                }
              }
            }
            this.loading.dashboard = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.dashboard = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
